module.exports = __webpack_public_path__ + "static/media/19ESCAP13.5aaaa09a.jpg";